/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const cloud_rain = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <g clipPath="url(#cloud_rain_svg__a)">
      <path
        fill="#000"
        d="m3.559 4.83.139.737-.14-.737Zm8.728 1.211-.743-.11a.75.75 0 0 0 .8.858l-.057-.748ZM1.8 14.47a.75.75 0 1 0 1.06 1.06L1.8 14.47Zm4.482 0a.75.75 0 1 0 1.06 1.06l-1.06-1.06Zm4.505 0a.75.75 0 1 0 1.06 1.06l-1.06-1.06Zm-6.426-.44A.75.75 0 1 0 3.3 12.97l1.06 1.06Zm4.482 0a.75.75 0 1 0-1.061-1.06l1.06 1.06Zm4.505 0a.75.75 0 1 0-1.061-1.06l1.06 1.06Zm-7.376-7.6a.75.75 0 0 0 1.283-.777l-1.283.776Zm-1.827 3.887A2.396 2.396 0 0 1 1.75 7.921H.25a3.896 3.896 0 0 0 3.896 3.896v-1.5ZM14.25 8.551c0 .975-.791 1.766-1.767 1.766v1.5a3.267 3.267 0 0 0 3.267-3.266h-1.5ZM4.146 11.817h8.337v-1.5H4.146v1.5ZM1.75 7.921c0-1.17.839-2.145 1.948-2.354l-.279-1.474A3.897 3.897 0 0 0 .25 7.921h1.5Zm2.554-3.006C4.526 2.97 6.268 1.75 7.92 1.75V.25c-2.293 0-4.785 1.675-5.108 4.495l1.49.17ZM7.92 1.75c2.417 0 3.919 2.18 3.623 4.182l1.484.219C13.441 3.356 11.364.25 7.921.25v1.5Zm4.423 5.039c1.006-.078 1.906.752 1.906 1.762h1.5c0-1.888-1.648-3.402-3.521-3.258l.115 1.496ZM3.698 5.567c.637-.12 1.102-.083 1.534.14l.688-1.333c-.828-.427-1.663-.44-2.5-.28l.278 1.473ZM3.3 12.97l-1.5 1.5 1.06 1.06 1.5-1.5-1.06-1.06Zm4.482 0-1.5 1.5 1.06 1.06 1.5-1.5-1.06-1.06Zm4.505 0-1.5 1.5 1.06 1.06 1.5-1.5-1.06-1.06ZM5.232 5.707c.195.1.382.272.532.446a2.726 2.726 0 0 1 .21.278v.001-.002h-.001l.642-.389.641-.388v-.001l-.001-.002a.68.68 0 0 0-.03-.047 4.226 4.226 0 0 0-.326-.43 3.384 3.384 0 0 0-.98-.8l-.687 1.334Z"
      />
    </g>
    <defs>
      <clipPath id="cloud_rain_svg__a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default cloud_rain
